import { useEffect } from 'react';
import { Box, List, Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import {
  fetchAllAgentContacts,
  fetchAgentGroups,
} from '../../../ccf-directory/+state/ccf-directory.slice';
import { getAgents, getAgentGroups } from '../+state/ccf-conversations.slice';
import { useSelector, useDispatch } from 'react-redux';
import { ConversationsAccordion } from '../conversations-accordion/conversations-accordion';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: '45px',
      padding: '8px 16px',
      margin: '0',
      '&$expanded': {
        minHeight: '45px',
        margin: '0',
      },
    },
    content: {
      '&$expanded': {
        margin: '10px 0px',
      },
    },

    navList: {
      width: '100%',
      padding: '0px',
      height: 'calc(100% - (74px))',
      overflowY: 'auto',
    },
    navListItemIcon: {
      justifyContent: 'left',
      minWidth: 40,
    },
    hoverDisabledButton: {
      padding: '0px',
      '&:hover': {
        background: 'inherit',
      },
    },
    listItemRoot: {
      alignItems: 'flex-start',
      justifyContent: 'center',
      paddingInline: 0,
    },
    listItemSelected: {
      background: '#526b7a',
    },
    captionText: {
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '11px',
      lineHeight: '15px',
      color: '#8C95A5',
    },
    listItemName: {
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '11px',
      lineHeight: '15px',
      color: '#404040',
      marginBottom: '4px',
    },
    groupIconRoot: {
      fontSize: '2rem',
    },
  })
);

/**
 * Component to be used for conversation side bar
 * @example <ConversationsSideBar />
 * @returns
 */
export const ConversationsAppSideBar = () => {
  const styles = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllAgentContacts());
    dispatch(fetchAgentGroups());
  }, []);

  const agents = useSelector(getAgents);
  const agentGroups = useSelector(getAgentGroups);
  const favouriteAgents = agents.filter((agent: any) => agent.isFavorite);
  const otherAgents = agents.filter((agent: any) => !agent.isFavorite);

  return (
    <List classes={{ root: styles.navList }}>
      <ConversationsAccordion
        children={favouriteAgents}
        caption="FAVORITES"
        showAddButton={false}
        type="favourite"
      />

      <Box my={1} />
      <ConversationsAccordion
        children={agentGroups}
        caption="GROUPS"
        showAddButton={true}
        type="group"
      />
      <Box my={1} />
      <ConversationsAccordion
        children={otherAgents}
        caption="DIRECT MESSAGES"
        showAddButton={false}
        type="direct"
      />
    </List>
  );
};
